import service from "./service"

const backgroundCheckForms = async () => {
    return service()
}

export default backgroundCheckForms